import { closeNav, initNav } from "./initNav.js";
import { initModal, closeActiveModal } from "./initModal.js";
import { initFilters } from "./initFilters.js";
import { initImages } from "./initImages.js";
import { initContactForm } from "./initContactForm.js";
import { initHomepage } from "./initHomepage.js";

import Swup from "swup";
import SwupScriptsPlugin from "@swup/scripts-plugin";
import SwupProgressPlugin from "@swup/progress-plugin";
import SwupBodyClassPlugin from "@swup/body-class-plugin";
import SwupHeadPlugin from "@swup/head-plugin";
import { initCustomSelects, initVariationSelect } from "./initCustomSelects.js";
import customSelect from "custom-select";

// We need to write some jQuery here to interact with
// the Search & Filter Pro  plugin.
(function ($) {
  "use strict";
  $(document).on("sf:ajaxfinish", ".searchandfilter", function () {
    initFilters();
    initImages();
    initCustomSelects(
      ".shop-filters [data-sf-field-name] > label > select",
      ".shop-filters"
    );
  });
  $(document).on("sf:init", ".searchandfilter", function () {
    initImages();
    initCustomSelects(
      ".global-filters [data-sf-field-name] > label > select",
      ".global-filters"
    );
  });
})(jQuery);

// Prevent WooCommerce from scrolling to shop messages
jQuery(document).ajaxComplete(function () {
  if (
    jQuery("body").hasClass("woocommerce-checkout") ||
    jQuery("body").hasClass("woocommerce-cart")
  ) {
    jQuery("html, body").stop();
  }
});

function init() {
  initNav();
  initModal();
  initFilters();
  initImages();
  initContactForm();
  initCustomSelects(
    ".shop-filters [data-sf-field-name] > label > select",
    ".shop-filters"
  );
  initCustomSelects(
    ".global-filters [data-sf-field-name] > label > select",
    ".global-filters"
  );
  if (
    document.body.classList.contains("home") ||
    document.body.classList.contains("title-signup")
  ) {
    initHomepage();
  }
  customSelect(".modal select");

  $(window).on("load", function () {
    initVariationSelect();
  });

  window.addEventListener(
    "touchstart",
    function onFirstTouch() {
      window.IS_TOUCH = true;
      // we only need to know once that a human touched the screen, so we can stop listening now
      window.removeEventListener("touchstart", onFirstTouch, false);
    },
    false
  );

  const subscribeButtons = document.querySelectorAll(".open-subscribe");
  const newsletterModal = document.querySelector(".modal.newsletter");
  const nav = document.querySelector(".site-nav");
  subscribeButtons.forEach((b) => {
    b.addEventListener("click", (e) => {
      e.preventDefault();
      closeNav(nav)
      document.body.classList.add("modal-active");
      newsletterModal.classList.add("active");
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const swup = new Swup({
    cache: false,
    linkSelector: "a[href][data-swup]",
    plugins: [
      new SwupScriptsPlugin({
        head: true,
        body: true,
      }),
      new SwupProgressPlugin(),
      new SwupBodyClassPlugin(),
      new SwupHeadPlugin(),
    ],
  });

  init();
  swup.on("contentReplaced", () => {
    init();
    closeNav();
  });
});
